import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/PreAdvise/PreadviseDetails.css';
import cancelicon from '../../../Assets/TruckVisits/Assets-Desktop/cancel-icon.svg';
import CancelModal from '../../Shared/CancelModal';
import SuccessModal from '../../Shared/SuccessModal';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class PreadviseDetails extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            SelectTerminal: 'Durban Pier One Container Terminal',
            LastMove: '16-Dec-2020',
            UnitNo: 'UZZI7771237',
            TypeISO: '22G1',
            Category: 'Export',
            TState: 'Inbound',
            LineOperator: 'MAE (MAERSK LINES)',
            IBActualVisit: 'GEN_TRUCK',
            OBActualVisit: 'Vessel',
            PortofDischarge: 'KHH',
            FreightKind: 'FCL',
            BookingNo: 'XXXXX',
            hasOpen: false,
            hasOpenYes: false,
        }
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        this.props.history.push('/PreadviseDetails', {})
    };
    onYesModal = () => {
        this.setState({ hasOpen: false });
        this.setState({ hasOpenYes: true });
    };
    onCloseYes = () => {
        this.setState({ hasOpenYes: false });
        this.props.history.push('/PreAdvise', {})
    };
    cancelPreadvise = () => {
        this.setState({ hasOpen: true });
    }
    render() {
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.preAdviseDetailsPageTitle} description={TitleDescription.preAdviseDetailsPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofullpredet">
                    <div id="caacsnobox1PreDetails">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Pre-advise Details</small>
                            </div>
                            <div id="PreadviseDetailsNAcceptMobile"
                                className="PreadviseDetailsNNavbarNameRight"
                                onClick={this.cancelPreadvise}
                            >
                                <img src={cancelicon} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                <small id="adsh1saveEnable" >Cancel Pre-advise</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <nav class="PreadviseDetailsNMobileNavbar">
                            <div className="PreadviseDetailsNNavbarNameRight" onClick={this.cancelPreadvise}>
                                <img src={cancelicon} class=" mr-1 pb-1" id="adssaveicon" alt="" loading="lazy" />
                                <small id="adsh1saveEnable" >Cancel Pre-advise</small>
                            </div>
                        </nav>
                        <hr class="hrCDMobile" />
                        <div class="caanotificationmaincardpd">
                            <div class="caaoncsdivlow1">
                                <div class="adscsdivlow2">
                                    Site Selection</div>
                            </div>
                            <div class="caadivup1uperterminal">
                                <div class="caadivup2p">
                                    <div class="caadivup3PreDetails">
                                        <small id="caaname">Terminal</small>
                                        <div className="pass-wrapper" id="caad07boldTop" >
                                            <small id="caad066enbold">{this.state.SelectTerminal}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup4p">
                                    <div class="caadivup55">
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">Last Move</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.LastMove}</small>
                                            </div>
                                        </div>
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">Unit No.</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.UnitNo}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5en">
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">Type ISO</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.TypeISO}</small>
                                            </div>
                                        </div>
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">Category</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.Category}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5en">
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">T-State</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.TState}</small>
                                            </div>
                                        </div>
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">Line Operator</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.LineOperator}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5en">
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">I / B Actual Visit</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.IBActualVisit}</small>
                                            </div>
                                        </div>
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">O / B Actual Visit</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.OBActualVisit}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5en">
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">Port of Discharge</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.PortofDischarge}</small>
                                            </div>
                                        </div>
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">Freight Kind</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.FreightKind}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5en">
                                        <div class="caadivup3PreDetails">
                                            <small id="caaname">Booking No.</small>
                                            <div className="pass-wrapper" id="caad07bold" >
                                                <small id="caad066enbold">{this.state.BookingNo}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01predet">
                    <Footer />
                </div>
                <div class="caanotifooter02predet">
                    <Footer2 />
                </div>
                <CancelModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal} onYesModal={this.onYesModal}>
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="successtext1createpreadvise">Are you sure you want to cancel the </small>
                            <small class="successtext1createpreadvise"> Pre-advise for the selected Unit?</small>
                        </div>
                    </div>
                </CancelModal>
                <SuccessModal hasOpen={this.state.hasOpenYes} onCloseModal={this.onCloseYes}>
                    <div>
                        <div class="successtext1outercreatepreadvisesuccess">
                            <small class="successtext1createpreadvise">Your Pre-advise has been </small>
                            <small class="successtext1createpreadvise"> cancelled successfully</small>
                        </div>
                    </div>
                </SuccessModal>
            </div>
        );
    }
}
export default PreadviseDetails;